const SEO = [
	{
		page: "home",
		description:
			"I'm Walstan, a software engineer who loves creating efficient and reliable solutions to complex problems. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: [
			"Walstan",
			"Walstan B",
			"Walstan Baptista",
			"Walstan github",
			"Walstan github.io",
		],
	},

	{
		page: "about",
		description:
			"Software Engineer with experience delivering efficient, scalable & reliable software solutions. Seeking opportunities as a dev/engineer in fields like Software Development, Automation, AI, and related areas.",
		keywords: [
			"Walstan",
			"Walstan B",
			"Walstan Baptista",
			"Walstan github",
			"Walstan github.io",
		],
	},

	{
		page: "projects",
		description:
			"Throughout my journey as a developer, I've taken on numerous projects, each of which has contributed to my growth and expertise. A substantial portion of these projects are open-source, providing an excellent opportunity for collaboration and knowledge sharing.",
		keywords: [
			"Walstan",
			"Walstan B",
			"Walstan Baptista",
			"Walstan github",
			"Walstan github.io",
			"Walstan Baptista projects",
			"Walstan project",
		],
	},

	{
		page: "contact",
		description:
			"I'm always up for a challenge, so if you have a project you want to bring to life, let's make it happen!",
		keywords: [
			"Walstan",
			"Walstan B",
			"Walstan Baptista",
			"Walstan github",
			"Walstan github.io",
			"Walstan Baptista contact",
			"Walstan contact",
		],
	},
];

export default SEO;
